import { getLoggedInUserInfo, hasFeatureAccess } from 'utils'

export default function getMenuData() {
  const userInfo = getLoggedInUserInfo()

  // Return empty array if no user info
  if (!userInfo) return []

  const { userRole, userId } = userInfo
  const isSuperAdmin = userRole === 'super_admin'
  const isHR = userRole === 'hr'

  // Common menu items for all roles
  const commonMenu = [
    {
      title: 'Dashboard',
      key: '2t2ghd',
      // url: '/dashboard/gamma',
      module: 'dashboard',
      icon: 'fe fe-home',
    },
  ]

  // Configuration menu items
  const configurationMenu = {
    title: 'Configuration',
    key: '6rq4ze6',
    url: '/Configuration',
    module: 'configuration',
    icon: 'fe fe-settings',
    children: [
      {
        title: 'Global Type Category',
        url: '/config/global-type-category',
        module: 'global_type_category',
        key: 'e38wke',
      },
      {
        title: 'Global Type',
        url: '/config/global-type',
        module: 'global_type',
        key: 'e38wkesds',
      },
      {
        title: 'Role and Permissions',
        url: '/config/permissions',
        module: 'role_and_permissions',
        key: 'e38wkew',
      },
      {
        title: 'Module Permission',
        url: '/config/module-permission',
        key: 'e38wkex',
        module: 'module_permission',
      },
      {
        title: 'Location',
        url: '/config/location',
        module: 'location',
        key: 'e8848wkdb',
      },
      {
        title: 'Hierarchy',
        url: '/config/hierarchy',
        module: 'hierarchy',
        key: 'e8848whglb',
      },
      {
        title: 'Terms and condition',
        url: '/config/term-and-condition',
        module: 'term_condition',
        key: 'e38wkea',
      },

      {
        title: 'Company Policy',
        url: '/config/company-policy',
        module: 'company_policy',
        key: 'eyu7wker',
      },
      {
        title: 'Leave Policy',
        url: '/config/leave-policy',
        module: 'leave_policy',
        key: 'lvoPrus',
      },
      {
        title: "Do And Don't",
        url: '/config/doAndDont',
        module: "Do And Don't",
        key: 'doanddont',
      },
    ],
  }

  // HR Management menu items
  const hrManagementMenu = {
    title: 'HR Management',
    url: '/EmployeeManagement',
    module: 'hr_management',
    key: '6rs4ze6',
    icon: 'fe fe-user',
    children: [
      {
        title: 'Employees',
        url: '/emp/all-employee',
        module: 'employees',
        key: 'e38ws34ke',
      },
      {
        title: 'Attendance',
        url: '/attendance',
        module: 'attendance',
        key: 'e38wk3fesds',
      },
      {
        title: 'Agents',
        url: '/emp/all-agents',
        module: 'agents',
        key: 'e38wk3feds',
        icon: 'glyphicon glyphicon-user',
      },
      {
        title: 'On Board',
        url: '/on-board',
        module: 'on_board',
        key: 'e38ws3412',
      },
      {
        title: 'Happy To Help',
        url: '/happy-to-help',
        module: 'happy_to_help',
        key: 'e38r4eqvd',
      },
      {
        title: 'Down time',
        url: '/down-time',
        module: 'down_time',
        key: 'e38wk3fdk',
      },
      {
        title: 'Roster',
        url: '/roster',
        module: 'roster',
        key: 'e38wk3fo',
      },
      {
        title: 'Exception',
        url: '/exception',
        module: 'exception',
        key: 'e38wk3fes',
      },
      {
        title: 'Payroll',
        url: '/emp/payroll',
        module: 'payroll',
        key: 'e38wk3feb',
      },
      {
        title: 'Calendar',
        url: '/calendar',
        module: 'calender',
        key: 'e38r4eq',
        icon: 'fa fa-calendar',
      },
      {
        title: 'Leave Approval',
        url: '/leave-request',
        module: 'leave_approval',
        key: 'e38kjd7',
      },
      {
        title: 'Documents',
        url: '/documents',
        module: 'documents',
        key: '4mn45rdg',
      },
    ],
  }

  // Reports menu items
  const reportsMenu = {
    title: 'Reports',
    url: '/report',
    module: 'reports',
    key: '6r767s4ze6',
    icon: 'fe fe-file-text',
    children: [
      {
        title: 'Attendance Report',
        url: '/attendance-report',
        module: 'attendance_report',
        key: 'e345s34ke',
      },
      {
        title: 'Leave Report',
        url: '/leave-report',
        module: 'leave_report',
        key: 'e38dwk4sds',
      },
    ],
  }

  // Employee menu items
  const employeeMenu = [
    // {
    //   title: 'Employees',
    //   url: '/emp/all-employee',
    //   module: 'employees',
    //   key: 'employees',
    // },
    {
      title: 'Attendance',
      url: '/attendance',
      module: 'attendance',
      key: 'attendance',
      icon: 'fa fa-calendar-check-o',
    },
    {
      title: 'On Board',
      url: '/on-board',
      module: 'on_board',
      key: 'on_board',
      icon: 'fa fa-user-plus',
    },
    {
      title: 'Staff',
      url: '/staff',
      module: 'staff',
      key: 'staff',
      icon: 'fe fe-users',
    },
    {
      title: 'Agents',
      url: '/emp/all-agents',
      module: 'agents',
      key: 'agents',
      icon: 'fa fa-user',
    },
    {
      title: 'Happy To Help',
      url: '/happy-to-help',
      module: 'happy_to_help',
      key: 'happy_to_help',
      icon: 'fa fa-meh-o',
    },
    {
      title: 'Down time',
      url: '/down-time',
      module: 'down_time',
      key: 'down_time',
      icon: 'fe fe-clock',
    },
    {
      title: 'Roster',
      url: '/roster',
      module: 'roster',
      key: 'roster',
      icon: 'fa fa-calendar',
    },
    {
      title: 'Exception',
      url: '/exception',
      module: 'exception',
      key: 'exception',
      icon: 'fa fa-ban',
    },
    {
      title: 'Calendar',
      url: '/calendar',
      module: 'calender',
      key: 'calendar',
      icon: 'fa fa-calendar',
    },
    {
      title: 'Leave Approval',
      url: '/leave-request',
      module: 'leave_approval',
      key: 'leave_approval',
      icon: 'fe fe-check-square',
    },
    // {
    //   title: 'Documents',
    //   url: '/documents',
    //   module: 'documents',
    //   key: 'documents',
    // },
    {
      title: 'Payroll',
      url: `/payroll/${userId}`,
      module: 'payroll',
      key: 'payroll',
      icon: 'fe fe-flag',
    },
    // {
    //   title: 'Reimbursement',
    //   url: '/reimbursement',
    //   module: 'reimbursement',
    //   key: 'reimbursement',
    //   icon: 'fe fe-file',
    // }
  ]

  // Additional menu items
  const additionalMenuItems = [
    {
      title: 'RAG Status',
      url: '/RAGstatus',
      module: 'ryg_status',
      key: '6rds4ze6',
      icon: 'fe fe-flag',
    },
    {
      title: 'Resignation',
      url: '/resignation',
      module: 'resignation',
      key: '6rds4ze1',
      icon: 'fa fa-sign-out',
    },
    {
      title: 'Teams',
      url: '/teams',
      module: 'teams',
      key: '8rds4zel',
      icon: 'fa fa-group',
    },
    {
      title: 'Acknowledgement',
      url: '/acknowledgement',
      module: 'acknowledgement',
      key: '6rd7854ze1',
      icon: 'fe fe-file',
    },
    {
      title: 'Expenses',
      url: '/expenses',
      module: 'expenses',
      key: '8sd34sde4',
      icon: 'fe fe-file',
    },
    {
      title: 'Reimbursement',
      url: '/reimbursement',
      module: 'reimbursement',
      key: '8s554sde4',
      icon: 'fe fe-file',
    },
  ]

  // Build menu based on user role
  const menuData = [...commonMenu]

  if (isSuperAdmin || isHR) {
    menuData.push(configurationMenu, hrManagementMenu, reportsMenu, ...additionalMenuItems)
  } else {
    menuData.push(...employeeMenu)
  }

  // Filter menu based on feature access
  const filterMenu = (menuItems) => {
    return menuItems.filter((item) => {
      if (item.children) {
        const filteredChildren = filterMenu(item.children)
        if (filteredChildren.length > 0) {
          item.children = filteredChildren
          return true
        }
        return false
      }
      return hasFeatureAccess(item.module)
    })
  }

  return filterMenu(menuData)
}
